import React from "react";
import HeadingView from "common/views/heading/Heading.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { Fragment } from "core/components/FragmentProvider";
import Label from "core/components/label/Label";
import constants from "../constants";
import { Article } from "./entities";

interface IArticleEditFragmentProps {
	article: Article;
}

export const tags: Fragment<IArticleEditFragmentProps> = {
	name: "Tags",
	enabled: (props) => !!props.article.tags && props.article.tags.length > 0,
	component: (props) => (
		<div>
			{/* <HeadingView viewKey="property.title">
				<Label k="tags" v="Tags" />
			</HeadingView> */}
			{props.article.tags.reduce((lst, tag, i) => {
				// if (i > 0) {
				// 	lst.push(
				// 		<React.Fragment key={tag.id + "-separator"}>
				// 			{", "}
				// 		</React.Fragment>
				// 	);
				// }

				lst.push(
					<PageLinkView
						key={tag.id}
						viewKey="tag.link"
						preserveParams={false}
						params={{ [constants.PARAM_TAG_IDS]: tag.id }}
					>
						<span
							style={{
								border: "1px solid #106ba3",
								borderRadius: "10px",
								padding: "3px 5px 3px 5px",
								color: "#106ba3",
								marginRight: "5px",
							}}
						>
							<Label k={`Tag.${tag.id}.name`} v={tag.name} />
						</span>
					</PageLinkView>
				);

				return lst;
			}, [])}
		</div>
	),
};

export const displayName: Fragment<IArticleEditFragmentProps> = {
	name: "Display Name",
	component: (props) => (
		<HeadingView viewKey="article.displayName">
			{props.article.displayName}
		</HeadingView>
	),
};



// WEBPACK FOOTER //
// ./src/panels/articleDetails/article/commonFragments.tsx